import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=4ef06a9f&scoped=true&"
import script from "./Photos.js?vue&type=script&lang=js&"
export * from "./Photos.js?vue&type=script&lang=js&"
import style0 from "./Photos.scss?vue&type=style&index=0&id=4ef06a9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef06a9f",
  null
  
)

export default component.exports